import {
  EquipmentOperationStatus,
  EquipmentOperationStatusLED,
} from "../../../common/types/equipment";
import { mcyStatusChanger } from "../../../common/util/mcyStatusChanger";
import * as S from "./SystemEquipBoard.style";
import { EquipStatusItem } from "../../atoms/EquipStatusItem";

import { ReactComponent as ImgSystem1000 } from "../../../styles/assets/svg/img_system_1000.svg";
import { ReactComponent as ImgSystem3000 } from "../../../styles/assets/svg/img_system_3000.svg";

interface SystemEquipBoardProps {
  shipType: "1000" | "3000" | string;
  equipmentOperationStatus: EquipmentOperationStatus;
  equipmentOperationStatusLED?: EquipmentOperationStatusLED;
  navigateToPath: (path?: string) => void;
  onContextMenu: (event: React.MouseEvent, target: any) => void;
}
export const SystemEquipBoard = ({
  shipType,
  equipmentOperationStatus,
  equipmentOperationStatusLED,
  navigateToPath,
  onContextMenu,
}: SystemEquipBoardProps) => {
  return (
    <S.SystemEquipBoard>
      {shipType === "1000" ? <ImgSystem1000 /> : <ImgSystem3000 />}

      <S.SystemEquipStatusList>
        {shipType === "1000" ? (
          <>
            <EquipStatusItem
              title="No.2 메인엔진"
              status="off"
              power={equipmentOperationStatus.machine16 === 1}
              $pRight="400px"
              $pTop="20px"
              path="/equipment/mainengine02/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />

            <EquipStatusItem
              title="No.3 메인엔진"
              status={mcyStatusChanger(equipmentOperationStatusLED?.gasturbine)}
              power={equipmentOperationStatus.machine13 === 1}
              $pRight="410px"
              $pBottom="42%"
              path="/equipment/mainengine03/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />

            <EquipStatusItem
              title="No.1 메인엔진"
              status={mcyStatusChanger(equipmentOperationStatusLED?.generator1)}
              power={equipmentOperationStatus.machine9 === 1}
              $pRight="400px"
              $pBottom="0px"
              path="/equipment/mainengine01/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />
            <EquipStatusItem
              title="No.3 발전기"
              status={mcyStatusChanger(equipmentOperationStatusLED?.generator2)}
              power={equipmentOperationStatus.machine10 === 1}
              $pTop="0px"
              $pRight="210px"
              path="/equipment/generator03/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />
            <EquipStatusItem
              title="No.2 발전기"
              status={mcyStatusChanger(equipmentOperationStatusLED?.generator3)}
              power={equipmentOperationStatus.machine11 === 1}
              $pRight="210px"
              $pBottom="56%"
              path="/equipment/generator02/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />
            <EquipStatusItem
              title="No.1 발전기"
              status={mcyStatusChanger(equipmentOperationStatusLED?.generator4)}
              power={equipmentOperationStatus.machine12 === 1}
              $pRight="210px"
              $pBottom="24%"
              path="/equipment/generator01/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />
          </>
        ) : (
          <>
            <EquipStatusItem
              title="No.4 발전기"
              status={mcyStatusChanger(equipmentOperationStatusLED?.generator3)}
              power={equipmentOperationStatus.machine11 === 1}
              $pTop="72px"
              $pLeft="240px"
              path="/equipment/generator04/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />

            <EquipStatusItem
              title="No.3 발전기"
              status={mcyStatusChanger(equipmentOperationStatusLED?.generator4)}
              power={equipmentOperationStatus.machine12 === 1}
              $pBottom="40px"
              $pLeft="240px"
              path="/equipment/generator03/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />
            <EquipStatusItem
              title="Gear Port"
              power={equipmentOperationStatus.machine14 === 1}
              $pTop="96px"
              $pLeft="362px"
              path="/equipment/gearport/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />

            <EquipStatusItem
              title="Gear Port"
              power={equipmentOperationStatus.machine14 === 1}
              $pBottom="40px"
              $pLeft="362px"
              path="/equipment/gearport/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />
            <EquipStatusItem
              title="No.2 추진전동기"
              power={equipmentOperationStatus.machine14 === 1}
              $pTop="96px"
              $pRight="316px"
              path="/equipment/propulsionmotor02/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />
            <EquipStatusItem
              title="No.1 추진전동기"
              power={equipmentOperationStatus.machine14 === 1}
              $pBottom="40px"
              $pRight="316px"
              path="/equipment/propulsionmotor01/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />

            <EquipStatusItem
              title="감속기어"
              status="off"
              power={equipmentOperationStatus.machine16 === 1}
              $pRight="276px"
              $pTop="162px"
              path="/equipment/gearbox/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />
            <EquipStatusItem
              title="감속기어"
              status="off"
              power={equipmentOperationStatus.machine16 === 1}
              $pRight="276px"
              $pBottom="156px"
              path="/equipment/gearbox/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />

            <EquipStatusItem
              title="No.1 발전기"
              status={mcyStatusChanger(equipmentOperationStatusLED?.generator1)}
              power={equipmentOperationStatus.machine9 === 1}
              $pBottom="78px"
              $pRight="140px"
              path="/equipment/generator01/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />
            <EquipStatusItem
              title="No.2 발전기"
              status={mcyStatusChanger(equipmentOperationStatusLED?.generator1)}
              power={equipmentOperationStatus.machine9 === 1}
              $pBottom="196px"
              $pRight="140px"
              path="/equipment/generator02/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />
            <EquipStatusItem
              title="No.3 발전기"
              status={mcyStatusChanger(equipmentOperationStatusLED?.generator1)}
              power={equipmentOperationStatus.machine9 === 1}
              $pTop="115px"
              $pRight="140px"
              path="/equipment/generator03/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />
            <EquipStatusItem
              title="No.4 발전기"
              status={mcyStatusChanger(equipmentOperationStatusLED?.generator1)}
              power={equipmentOperationStatus.machine9 === 1}
              $pTop="-3px"
              $pRight="140px"
              path="/equipment/generator04/0"
              navigateToPath={navigateToPath}
              onContextMenu={onContextMenu}
            />
          </>
        )}
      </S.SystemEquipStatusList>
    </S.SystemEquipBoard>
  );
};
